import React from "react";
import { Box, Typography } from "@mui/material";
import FMBlogo from "../../assets/FMBlogo1.png";

const UserNavbar = ({company_id}) => {
   // console.log(company_id, "company_id");
    // Get the appropriate logo based on company_id, fallback to default
    const getLogoPath = () => {
        if (!company_id) {
            return FMBlogo; // Default logo when no company_id
        }
        
        try {
            // Try to load company-specific logo
            return require(`../../assets/FMBlogo${company_id}.png`);
        } catch (error) {
            // Fallback to default logo if company-specific logo doesn't exist
            console.warn(`Logo for company ${company_id} not found, using default logo`);
            return FMBlogo;
        }
    };

    return (
        <Box textAlign="center" py={2}>
            <img src={getLogoPath()} alt="Fargerike Logo" style={{ height: 100 }} />
            <Typography sx={{ 
                fontSize: { xs: "1.3rem", sm: "1.5rem", md: "2rem" },
                fontWeight: 550,
                lineHeight: 1.2,
                px: { xs: 2, sm: 0 }
            }}>
                Velkommen til hyggelig handel hos Fargerike Majorstuen!
            </Typography>
        </Box>
    );
};

export default UserNavbar;
